import isEqual from 'lodash/isEqual';
import { useAppSelector } from '../store';

export default function useCheckoutProcess() {
  return useAppSelector(state => state.session.checkoutProcess, isEqual);
}
